<template>
	<div>
		<b-breadcrumb>Services</b-breadcrumb>
		<service-list></service-list>
	</div>
</template>

<script>
import ServiceList from '@/components/Service/List';

export default {
	name: 'Services',
	components: {
		ServiceList
	},
};
</script>
